import { useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import * as sentryProvider from './sentry';

const useSentry = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  const sentryUser = user.email ? user : null;

  const init = () => {
    const sentry = sentryProvider.createSentry(sentryUser);

    if (!sentry) {
      throw new Error('Sentry is not initialized.');
    }

    sentry.init();
  };

  return [init];
};

export default useSentry;
